module.exports = __webpack_public_path__ + "img/lr.92052c1a.svg";